/**
 * <https://docs.google.com/document/d/1FTascZXT9cxfetuPRT2eXPQKXui4nWFivUnS_335T3U>
 */
export function registerDevtoolsFormatter(formatter: DevtoolsFormatter): void {
  const gw: any = typeof (<any>window) === "undefined" ? global : window;

  if (gw.devtoolsFormatters === undefined) {
    gw.devtoolsFormatters = [];
  }

  gw.devtoolsFormatters.push(formatter);
}

export interface DevtoolsFormatter {
  header: (obj: any) => any[] | null | undefined;
  hasBody: (obj: any) => boolean | null | undefined;
  body: (obj: any) => any[] | null | undefined;
}

// Helpers:

export const listStyle = {
  style: "list-style-type: none; padding: 0; margin: 0 0 0 12px; font-style: normal",
};
export const immutableNameStyle = { style: "color: rgb(232,98,0)" };
export const keyStyle = { style: "color: #881391" };
export const nullStyle = { style: "color: #777" };

export function renderCollectionHeader(size: number, name: string): any[] {
  return ["span", ["span", immutableNameStyle, name], ["span", `[${size}]`]];
}

export function reference(object: any): any[] {
  if (typeof object === "undefined") {
    return ["span", nullStyle, "undefined"];
  } else if (object === "null") {
    return ["span", nullStyle, "null"];
  }

  return ["object", { object: object }];
}
